export const translation = {
	Hello: 'Hello',
	World: 'World',
};
